'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function LightUp(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 8 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 5 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-carets-up ' + className, width: width, height: height, viewBox: '0 0 8 5' },
    _react2.default.createElement('polygon', { fill: color, fillRule: 'evenodd', points: '4 0 8 5 0 5' })
  );
}

LightUp.propTypes = _bcPropTypes.iconShape;

exports.default = LightUp;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Carets/Up/Up.js
// module id = 1137
// module chunks = 1